import { openBlock as t, createElementBlock as o, createElementVNode as n } from "vue";
const r = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
};
function l(a, e) {
  return t(), o("svg", r, [...e[0] || (e[0] = [
    n("path", {
      fill: "currentColor",
      d: "M12 6a.75.75 0 0 1 .75.75v4.5h4.5a.75.75 0 0 1 0 1.5h-4.5v4.5a.75.75 0 0 1-1.5 0v-4.5h-4.5a.75.75 0 0 1 0-1.5h4.5v-4.5A.75.75 0 0 1 12 6"
    }, null, -1)
  ])]);
}
const c = { render: l };
export {
  c as default,
  l as render
};
